import { useQuery } from '@tanstack/react-query'
import { zetApi } from '@zet/network'

interface IDecodedToken {
  actionData: {
    phoneNumber: string
    customerId?: number
    jfsConsent: object
    hash?: string
  }
  action?: any
}

export const useGetDecryptToken = (token: string) => {
  return useQuery<IDecodedToken>(
    ['jfsDecryptToken', token],
    () => getDescryptJwtToken(token),
    {
      enabled: !!token,
      cacheTime: 0,
      staleTime: 0,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    }
  )
}

export const getDescryptJwtToken = async (token: string) => {
  const { data } = await zetApi.post(`jfs/decryptToken?jwtToken=${token}`)
  if (data?.data) {
    return data.data
  } else {
    return data?.error
  }
}
